<template>
  <div>
    <!-- smartsoft settings -->
    <p class="title is-5">SmartSoft settings</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Lobby url</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="smartsoftSettings.lobbyUrl" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Portal name</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="smartsoftSettings.portalName" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Real username</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="smartsoftSettings.realUsername" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label">
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            <button @click="save" class="button is-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import smartsoftService from '../../../../services/smartsoft.service';

  export default {
    name: 'client-settings-smartsoft',
    data() {
      return {
        smartsoftSettings: {
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      this.smartsoftSettings = await smartsoftService.getSettingsByClient(this.clientId);
    },
    methods: {
      async save() {
        await smartsoftService.save(this.clientId, this.smartsoftSettings);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/smartsoft.vue